
import { module } from 'modujs';
import Matter from 'matter-js';
import gsap from 'gsap';
import { onRAF } from '../utils/onRAF';
import { random } from '../utils/maths';
import { shuffle } from '../utils/array';

// module aliases
let Engine = Matter.Engine,
Render = Matter.Render,
Runner = Matter.Runner,
Bodies = Matter.Bodies,
Composite = Matter.Composite;

let themes = [
	'-yellow',
	'-green',
	'-gray'
];

export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			click: {
				wrap: 'click'
			}
		}
    }

    init() {

		this.list = this.getData('keywords').split(',');
		this.listIterator = 0;
		shuffle(this.list);

		this.iterator = 0;
		this.limit = 15;

		this.resizeDebounce();

		// create an engine
		this.engine = Engine.create();

		// create a renderer
		this.render = Render.create({
			element: this.$('wrap')[0],
			engine: this.engine,
			options: {
				width: this.bcr.width,
				height: this.bcr.height,
				wireframes: false,
				background: 'transparent'
			}
		});

		this.render.canvas.style.position = 'absolute';
		this.render.canvas.style.top = 0;
		this.render.canvas.style.left = 0;
		this.render.canvas.style.right = 0;
		this.render.canvas.style.bottom = 0;
		this.render.canvas.style.zIndex = -1;
		this.render.canvas.style.pointerEvents = 'none';

		// run the renderer
		Render.run(this.render);

		// create runner
		var runner = Runner.create();

		// run the engine
		Runner.run(runner, this.engine);

		gsap.delayedCall(window.readyDelay,() => {
			this.initShapes();

			// Events
			this.bindResize = this.resize.bind(this);
			window.addEventListener("resize", this.bindResize);

			this.unregisterRAF = onRAF(() => this.rerender());
		});
    }

	initShapes() {
		this.ground = Bodies.rectangle(this.bcr.width/2, this.bcr.height + 5, this.bcr.width, 10,{ 
			isStatic: true,
			render: {
				fillStyle: 'transparent'
			}
		});

		let leftWall = Bodies.rectangle(-5, this.bcr.height/2, 10, this.bcr.height, { 
			isStatic: true,
			render: {
				fillStyle: 'transparent'
			}
		 });
		let rightWall = Bodies.rectangle(this.bcr.width + 5, this.bcr.height/2, 10, this.bcr.height, { 
			isStatic: true,
			render: {
				fillStyle: 'transparent'
			}
		});

		Composite.add(this.engine.world, [this.ground, leftWall, rightWall]);

		this.boxes = [];
		for (let index = 0; index < 10; index++) {
			let offset = (Math.random()*this.bcr.width/5) - this.bcr.width/10;

			this.addShape(this.bcr.width/2 + offset,(this.bcr.height/2),0.4*index);
		}
	}

	click(e) {
		this.addShape(e.clientX, e.clientY + window.scrollInstance.scroll);

	}
	addShape(x,y,delay = 0) {

		let element = document.createElement('div');
		element.classList.add('js-error-box');
		element.classList.add('c-error_box');
		element.classList.add('u-invisible');

		element.textContent = this.list[this.listIterator];
		if(random() > 0.6) {
			let theme = themes[Math.round(random(0,themes.length-1))]
			element.classList.add(theme);
		}

		if(this.listIterator < this.list.length - 1) {
			this.listIterator++;
		} else {
			this.listIterator = 0;
		}

		this.el.appendChild(element);

		let w = element.getBoundingClientRect().width;
		let h = element.getBoundingClientRect().height; 
		
		const box = {
			w: w,
			h: h,
			body: Matter.Bodies.rectangle(x, y, w, h, {
				chamfer: {
					radius: [h/2,h/2,h/2,h/2]
				},
				render: {fillStyle: 'transparent'}
			}),
			elem: element,
			render() {
				const {x, y} = this.body.position;
				this.elem.classList.remove('u-invisible');
				this.elem.style.top = `${y - this.h / 2}px`;
				this.elem.style.left = `${x - this.w / 2}px`;
				this.elem.style.transform = `rotate(${this.body.angle}rad)`;
			}
		};

		if(this.iterator <= this.limit) {
			this.iterator++;
		} else {
			Composite.remove(this.engine.world, [this.boxes[0].body]);
			this.boxes.shift();
			let firstBox = document.querySelectorAll('.js-error-box')[0];
			firstBox.parentNode.removeChild(firstBox);
		}

		gsap.delayedCall(delay,() => {
			this.boxes.push(box);
			Composite.add(this.engine.world, [box.body]);

		});
	}

	rerender() {
		if(this.boxes.length > 0) {
			this.boxes.forEach(box => {
				box.render();
			});
		}
	}

	getBCR() {
		this.bcr = this.el.getBoundingClientRect();
	}


	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		this.getBCR();

		if(this.render != undefined) {
			this.render.canvas.width = this.bcr.width;
			this.render.canvas.style.width = `${this.bcr.width}px`;
			this.render.canvas.height = this.bcr.height;
			this.render.canvas.style.height = `${this.bcr.height}px`;

			Composite.clear(this.engine.world);
			document.querySelectorAll('.js-error-box').forEach(box => {
				box.parentNode.removeChild(box);
			});
			this.iterator = 0;
			
			this.initShapes();
		}

		
	}

	destroy() {
		this.unregisterRAF();

	}
}
